'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// Small additions on top of the reused .pew-* form styles: the Disabled checkbox row and the required-field mark.
const UCW_CSS = /*css*/`
	.ucw-check { display: inline-flex; align-items: center; gap: 0.5rem; font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); cursor: pointer; }
	.ucw-check input { width: 1rem; height: 1rem; }
	.ucw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
`;

/**
 * UserCreateWorkspace — the bespoke User CREATE screen (reached by the app-router Create bridge on
 * #/PSRS/User/Create, which shadows the generic recordset create form so "+ New" opens the curated experience
 * instead of the plain manifest form). A thin shell: all data, behavior, and hand-built form HTML live in the
 * UserCreateWorkspace provider, which assigns into the #UCW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class UserCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.UserCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'UserCreateWorkspace',
	DefaultRenderable: 'UserCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reuse the Edit workspace's .pew-* styles verbatim (injection is idempotent by class), plus this screen's
	// two small additions.
	CSS: libProjectEditWorkspace.default_configuration.CSS + UCW_CSS,
	Templates:
	[
		{
			Hash: 'UserCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="UCW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserCreateWorkspaceWrap',
			TemplateHash: 'UserCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
